/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид поля выбора города на странице "Информации о доставке".
   * @param {app.SettlementForm} settlement Модель поселения
   * @param {jQuery} $opener DOM-элемент открывателя попапа
   */
  app.ChoiceCityDeliveryView = app.View.extend({
    /** @inheritDoc */
    el: '.info-delivery-settlement-popup',

    /** @inheritDoc */
    additionalOptions: ['$opener'],

    /** @inheritDoc */
    events: {
      'click .input-clear': 'clearInput',
      'focus #delivery-settlement_input': 'clearInput',
    },

    /** @inheritDoc */
    run: function () {
      this.$input = this.$('#delivery-settlement_input');
      this.childViews.cityAutocomplete = new app.SettlementAutocompleteView({
        appendTo: this.$('.delivery-settlement_autocomplete'),
        el: this.$input,
        settlement: this.settlement,
      });
      this.listenTo(this.childViews.cityAutocomplete, 'autocompleteDone', this.setSettlement);
      this.listenTo(this.settlement, 'sync', this.updateSettlement);
      this._initPopup();
      this.updateSettlement(this.settlement);
    },

    /**
     * Инициализация попапа выбора города.
     * @private
     */
    _initPopup: function () {
      this.popup = new als.Popup(this.$el, this.$opener);
      this.popup.addEventListener(als.Popup.EventType.BEFORE_OPEN, this._handlePopupOpen.bind(this));
    },

    /**
     * Выполняется перед открытием попапа с выбором населённого пункта.
     */
    _handlePopupOpen: function () {
      var cornerOffset = 10;
      this.$el.css({
        top: this.$opener.offset().top + this.$opener.height() + cornerOffset,
        left: this.$opener.offset().left,
      });
    },

    /**
     * Сохранение поселения в модель.
     * @param {Number} settlementId Идентификатор поселения
     */
    setSettlement: function (settlementId) {
      if (settlementId && settlementId !== this.settlement.get('settlement_id')) {
        this.settlement.save({'settlement_id': settlementId});
        Backbone.trigger('init-current-data');
      }
    },

    /**
     * Очищает поле ввода при клике на крестик и фокусе на input.
     */
    clearInput: function () {
      this.$input.val('');
    },

    /**
     * Обновление элементов с названием поселения.
     * @param {app.SettlementForm} model Модель поселения.
     */
    updateSettlement: function (model) {
      var value = model.get('name') + ' (' + model.get('region') + ')';
      this.$input.val(value);
      this.$opener.html(app.isMobile ? value : value.replace(/\s/g, '&nbsp;'));
    },
  });
})();

}.call(window));